/*global __CLIENT__*/
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Map, List } from 'immutable';
import immutableCreatorSelector from '../selectors/immutableCreatorSelector';
import ToastContainer from '../components/ToastContainer';
// import NavBar from '../components/toolbars/NavBar';
import FullScreenModal from '../components/modals/FullScreenModal';
import { OrganizationAccounts } from '../components/OrganizationAccounts';
import { ProjectActions } from '../actions/project';
import { AuthActions } from '../actions/auth';
import { currentUserSelector } from '../reducers/users';

// import IconNavList from '../components/toolbars/IconNavList';
import NavBarNew from '../components/toolbars/NavBarNew';

if (__CLIENT__) {
  require('../styles/Dashboard.css');
}

class Dashboard extends PureComponent {
  static propTypes = {
    showModal: PropTypes.bool,
    currentUser: PropTypes.instanceOf(Map),
    userAccounts: PropTypes.instanceOf(Map),
  };

  static contextTypes = {
    store: PropTypes.object.isRequired,
    accounts: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
    ]),
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(AuthActions.getMeAccounts());
  }

  render() {
    const { userAccounts, currentUser, dispatch } = this.props;

    return (
      <div className="main-container">
        <ToastContainer />
        {/* <NavBar /> */}
        <div className="dashboard-container">
          <NavBarNew />
          <div className="row" style={{ marginLeft: 50 }}>
            <div className="col-xs-12 projects p-3">
              <div className="row">
                <h2 className="section-header pull-left">Accounts</h2>
              </div>
              <div className="row box-container">
                <OrganizationAccounts
                  accounts={userAccounts}
                  currentUser={currentUser}
                  dispatch={dispatch}
                />
              </div>
            </div>
          </div>
        </div>
        <FullScreenModal />
      </div>
    );
  }
}

const userAccountsSelector = state => {
  const userId = currentUserSelector(state).get('id');
  const accountIds = state.users.getIn(
    ['users', userId, 'roles', 'account'],
    Map(),
  );
  const accounts = accountIds.map((role, accountId) =>
    state.accounts.getIn(['accounts', accountId]),
  );
  return accounts;
};

const accountsSelector = state => {
  const accounts = state.accounts.getIn(['accounts'], List());
  return accounts;
};

const AccountsContainerSelector = immutableCreatorSelector(
  [accountsSelector, currentUserSelector, userAccountsSelector],
  (accounts, currentUser, userAccounts) => ({
    accounts,
    currentUser,
    userAccounts,
  }),
);

@connect(AccountsContainerSelector)
export default class DashboardContainer extends PureComponent {
  static propTypes = {
    dispatch: PropTypes.func,
    currentUser: PropTypes.instanceOf(Map),
    accounts: PropTypes.oneOfType([
      PropTypes.instanceOf(List),
      PropTypes.instanceOf(Map),
    ]),
    userAccounts: PropTypes.instanceOf(Map),
  };

  render() {
    const { dispatch, accounts, userAccounts, currentUser } = this.props;
    return (
      <Dashboard
        accounts={accounts}
        userAccounts={userAccounts}
        dispatch={dispatch}
        currentUser={currentUser}
        {...bindActionCreators(ProjectActions, dispatch)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/Accounts.js